// extracted by mini-css-extract-plugin
export var container = "_gr-0";
export var icon = "_gr-1";
export var text = "_gr-2";